module.exports = "/images/Mexico.png?ceab90796bc7e488f066e79574a6c219";